/**
 * Dummy template data. Templates are a Family-Calendar-only concept
 * (Google Calendar has no notion of them), so this stays local/app
 * data even after Google Calendar sync is wired up — templates just
 * prefill the fields of a new event before it's created via
 * eventsApi.createEvent().
 *
 * `icons` is an ordered array (0〜4個, 選択順を維持) — see
 * src/constants/iconCatalog.js for the picker this is built from.
 */
export const mockTemplates = [
  { id: 'tpl-1', icons: ['⚽', '👦'], name: 'サッカー教室', place: '〇〇スポーツ広場', memo: '水筒とタオルを持参', notify: '30分前', color: '#3F6659' },
  { id: 'tpl-2', icons: ['🎹', '👧'], name: 'ピアノ教室', place: '〇〇音楽教室', memo: '楽譜と教本を持参', notify: '30分前', color: '#5B72B8' },
  { id: 'tpl-3', icons: ['👶', '🏥'], name: '定期健診', place: '〇〇小児科', memo: '母子手帳を持参', notify: '前日 20:00', color: '#D46BA3' },
  { id: 'tpl-4', icons: ['👩', '🛒'], name: '買い物', place: '〇〇スーパー', memo: '買い物リスト確認', notify: '通知しない', color: '#C68A00' },
  { id: 'tpl-5', icons: ['🏫'], name: 'PTA会議', place: '〇〇小学校', memo: '資料を印刷しておく', notify: '1時間前', color: '#FF8A65' },
  { id: 'tpl-6', icons: ['👨‍👩‍👧‍👦', '🎂', '🎉'], name: '誕生日会', place: '自宅', memo: 'ケーキとプレゼント準備', notify: '前日 20:00', color: '#8D6E9E' },
  { id: 'tpl-7', icons: ['👴', '🏥'], name: '病院', place: '〇〇クリニック', memo: '保険証を持参', notify: '30分前', color: '#D46BA3' },
  { id: 'tpl-8', icons: [], name: '美容室', place: '〇〇ヘアサロン', memo: '予約時間の5分前に到着', notify: '1時間前', color: '#7C7A6D' },
];

export const COLOR_PALETTE = ['#3F6659', '#5B72B8', '#FF8A65', '#D46BA3', '#C68A00', '#7C7A6D', '#4E8FA6', '#8D6E9E'];
